import React from 'react';

interface Props { message: string; onRetry?: () => void; }

export default function ErrorBanner({ message, onRetry }: Props) {
  const boxSt: React.CSSProperties = {
    margin: 16, padding: 12, borderRadius: 14,
    background: 'rgba(255,69,58,0.15)',
    color: 'var(--tg-theme-destructive-text-color)',
    fontSize: 13,
  };
  const pSt: React.CSSProperties = { margin: 0 };
  const btnSt: React.CSSProperties = {
    marginTop: 8, fontSize: 12, textDecoration: 'underline',
    background: 'none', border: 'none', cursor: 'pointer',
    color: 'inherit', opacity: 0.8, padding: 0, display: 'block',
  };
  return (
    <div style={boxSt}>
      <p style={pSt}>{message}</p>
      {onRetry && <button onClick={onRetry} style={btnSt}>Повторить</button>}
    </div>
  );
}
